import { CaseRunCalculateDetailModel, CaseRunClient } from "@app/api2/api";
import * as React from "react";
import { Grid, GridColumn, GridRow, Modal, ModalActions, ModalContent, ModalHeader } from "@/components/bp/bp-ui";
import { areYouSure2 } from "../../AreYouSure";
import BPLoading from "@common/BPLoading";
import { CalculationDetails } from "./CalculationDetails";
import { CalculationResults } from "./CalculationResults";
import { BPButton } from "@/components/bp/bpbutton";

interface ICalculationDetailModalProps {
    calculationId: number;
    caseRunId: number;
    labId: number;
    caseId: number;

    goBack: () => void;
    closeButtonLabel: string;
    header: string;
}

export function CalculationDetailsModal(props: ICalculationDetailModalProps) {
    const client = new CaseRunClient()
    const [model, setModel] = React.useState(null as CaseRunCalculateDetailModel)

    const deleteCalculation = async () => {
        if (model.isActive) {
            areYouSure2({
                message: window.translation.caseRun.calculationDeleteConfirm,
                title: window.translation.common.confirmDisable,
                action: async () => {
                    await client.deleteCalculation(props.labId, props.caseId, props.caseRunId, props.calculationId)
                    setModel({...model, isActive: false})
                }
            })
        } else {
            await client.restoreCalculation(props.labId, props.caseId, props.caseRunId, props.calculationId)
            setModel({...model, isActive: true})
        }
    };


    React.useEffect(() => {
        async function fetch() {
            let res = await client.getCalculationDetails(props.labId, props.caseId, props.caseRunId, props.calculationId)
            setModel(res)
        }

        fetch()
    }, [])

    return (
        <Modal size={'fullscreen'}
            onClose={() => props.goBack()}
            open={true}>
            <ModalHeader>{props.header}</ModalHeader>
            <ModalContent scrolling>
                {model == null ? <BPLoading /> : <Grid>
                    <GridRow columns={'equal'}>
                        <GridColumn>
                            <CalculationDetails model={model} />
                        </GridColumn>
                        <GridColumn>
                            <CalculationResults model={model}></CalculationResults>
                        </GridColumn>
                    </GridRow>
                </Grid>}
                {/* <iframe src={atob(props.calculationUrl)} style={{ border: 0, padding: 0, margin: 0, width: '100%', height: '70vh' }}></iframe> */}
            </ModalContent>
            <ModalActions>
                <BPButton negative={model?.isActive} positive={!model?.isActive} onClick={() => deleteCalculation()}>
                    {model?.isActive ? window.translation.common.disable : window.translation.common.enable}
                </BPButton>
                <BPButton onClick={() => props.goBack()}>
                    {props.closeButtonLabel}
                </BPButton>
            </ModalActions>
        </Modal>
    );
}


